import { computed, Injectable, signal } from '@angular/core';
import { ICardType } from '../interfaces/ICardType';
import { IIssuer } from '../interfaces/IIssuer';
import { IIdAndName } from '../../../../core/interfaces/IIdAndName';

@Injectable({
  providedIn: 'root'
})
export class CardsStore {

  public readonly issuers = signal<IIssuer[]>([]);
  public readonly productGroups = signal<IIdAndName<number>[]>([]);
  public readonly cardTypes = signal<ICardType[]>([]);
  public readonly sellableCardTypes =
    computed(() => this.cardTypes().filter(x => x.salesTaxTypeId));
  public readonly usableCardTypes = signal<ICardType[]>([]);
  public readonly allCardTypes = computed<ICardType[]>(() => {
    return [...this.cardTypes(), ...this.usableCardTypes()]
      .filter(
        (type, index, self) =>
          index === self.findIndex(t => t.cardTypeId === type.cardTypeId)
      );
  });

  public isAuthorizeOnly(cardType: ICardType): boolean {
    return !cardType.flagCashCard && cardType.flagReductionCard && cardType.flagNotLoadable;
  }
}
